import React, {useState} from 'react';
import './textEditorInput.scss';
import {useDebouncedCallback} from 'use-debounce';

interface TextEditorInputProps {
    onChange: (item: number) => void;
    defaultValue?: number;
    max?: number;
    step?: number;
}

function TextEditorInput({onChange, defaultValue = 0, max, step = 1}: TextEditorInputProps): JSX.Element {
    const [value, setValue] = useState<number>(defaultValue);

    const debouncedOnChange = useDebouncedCallback((value: number): void => {
        onChange(value);
    }, 700);

    const handleChange = (event: React.ChangeEvent<HTMLInputElement>): void => {
        const newValue = event.target.valueAsNumber;
        if (Number(newValue) && (max === undefined || newValue <= max)) {
            setValue(newValue);
            debouncedOnChange(newValue);
        }
    };

    return (
        <div className="c-sidepanel__input">
            <input type="number" value={value} onChange={handleChange} className="text-editor-input" max={max} step={step} />
        </div>
    );
}

export default TextEditorInput;
